import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ACCESS from 'utils/Access'
import StartConversation from './StartConversation'

import * as EndUserSelectors from 'app/modules/endUser/selectors'
import * as EndUserActions from 'app/modules/endUser/actions'

//replace these
import ActivitySection from 'components/conversation/ContactSideBar/Person/ActivitySection'
import EndUserAttributesCard from 'components/customer/EndUserAttributesCard'
import SegmentsCard from 'components/customer/SegmentsCard'
import Loading from 'shared-web/src/components/Loading'
import SalesforceSection from 'components/conversation/ContactSideBar/Person/SalesforceSection'
import HubSpotSection from 'components/conversation/ContactSideBar/Person/HubSpotSection'

import './style.styl'
import ContactHeader from "./ContactHeader"
import { isIntegrationConnected } from 'utils/Integrations'


class ContactRecordLite extends Component {
  static propTypes = {
    user: PropTypes.object,
    listenForSideBarClose: PropTypes.func,
    listenForMessageSent: PropTypes.func,
    userStatus: PropTypes.shape({
      lastUpdateAt: PropTypes.number,
      onlineAt: PropTypes.number,
      isConnected: PropTypes.bool,
      geo: PropTypes.object
    })
  }

  static defaultProps = {
    userStatus: {}
  }

  updateFollow = () => {
    this.props.actions.updateFollowing({
      following: !this.props.following,
      id: this.props.user.id,
    })
  }

  renderActivity() {
    return (
      <section className="lite-contact-activity">
        <ActivitySection endUserId={this.props.user.id}/>
      </section>
    )
  }

  renderAbout() {
    return (
      <section className="lite-contact-about">
        <EndUserAttributesCard hideAllAttributesModal endUser={this.props.user}/>
      </section>
    )
  }

  renderSalesforceEnrichment = () =>
    <section className="lite-contact-about">
      <SalesforceSection email={this.props.user.email}/>
    </section>

  renderHubSpotEnrichment = () =>
    <section className="lite-contact-about">
      <HubSpotSection email={this.props.user.email}/>
    </section>

  renderSegments() {
    return (
      <section className="lite-contact-segments">
        <SegmentsCard endUserId={this.props.user.id} />
      </section>
    )
  }

  renderInfoSection() {
    const { user, userStatus, following } = this.props
    return (
      <ContactHeader
        user={user}
        userStatus = {userStatus}
        hasFollowing={this.props.hasFollowing}
        following={following}
        updateFollowing={this.updateFollow}/>
    )
  }


  render() {
    const { listenForMessageSent, user, hasSalesforce, hasHubSpot } = this.props

    return (
        <div className="contact-record-lite">
          {this.renderInfoSection()}
          {user && user.id
            ? (
              <div>
                {<StartConversation userId={user.id} userType={this.props.user.type} listenForMessageSent={listenForMessageSent}/>}
                {this.renderActivity()}
                {hasSalesforce && this.renderSalesforceEnrichment()}
                {hasHubSpot && this.renderHubSpotEnrichment()}
                {this.renderAbout()}
                {this.renderSegments()}
              </div>
            )
            : (
              <div className="flex-center" style={{ marginTop: '75px' }}>
                <Loading size="large" color="#7695A5" />
              </div>
            )
          }
        </div>
    )
  }
}

const makeMapStateToProps = () => {
  return (state, props) => ({
    following: props.user.id && EndUserSelectors.followingId(props.user.id)(state),
    hasFollowing: ACCESS.hasGates('has_following'),
    hasSalesforce: isIntegrationConnected('salesforce'),
    hasHubSpot: isIntegrationConnected('hubspot'),
  })
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchFollowing: EndUserActions.fetchFollowing,
      updateFollowing: EndUserActions.updateFollowing,
    },
    dispatch
  )
})

export default connect(makeMapStateToProps, mapDispatchToProps)(ContactRecordLite)



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ContactRecordLite/index.js